import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  Select,
  Typography,
  Upload,
} from "antd";
import {
  FileImageOutlined,
  FileOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import { Gift, Upload as UploadIcon } from "lucide-react";
import React, { useEffect } from "react";
import { getFilePath } from "../../config/app-config";

const { Paragraph } = Typography;
const { Option } = Select;

const KYCInformations = ({ form, onContinue, onChangeFormValues }) => {
  const handleSubmit = (values) => {
    onContinue(values);
  };

  const renderUpload = (label, fieldName, required) => (
    <Col span={8}>
      <Form.Item
        name={fieldName}
        label={label}
        valuePropName="fileList"
        getValueFromEvent={(e) => (Array.isArray(e) ? e : e?.fileList)}
        rules={
          required
            ? [{ required: true, message: `Please upload your ${label}` }]
            : []
        }
      >
        <Upload
          name="file"
          listType="text"
          beforeUpload={() => false}
          onChange={(info) => onChangeFormValues(fieldName, info.fileList)}
        >
          <Button icon={<UploadOutlined />}>Click to Upload</Button>
        </Upload>
      </Form.Item>
    </Col>
  );

  return (
    <Card
      title="Basic Information"
      style={{
        marginTop: 32,
        width: "100%",
        maxWidth: 400,
        maxHeight: "80vh", // Restrict height
        overflowY: "auto", // Enable vertical scrolling
      }}
    >
      <Paragraph className="text-center text-muted">
        Tell us a bit about yourself (Tier 2 KYC)
      </Paragraph>

      <Form layout="vertical" form={form} onFinish={handleSubmit}>
        {renderUpload("Address Proof", "addressProofFile", false)}
        {renderUpload("ID Proof", "idProofFile", false)}
        {renderUpload("Other Proof", "otherProofFile", false)}

        {/* Submit Button */}
        <Form.Item>
          <Button
            type="primary"
            size="large"
            block
            style={{
              backgroundColor: "#1d4ed8",
              borderColor: "#1d4ed8",
            }}
            htmlType="submit"
          >
            Continue
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default KYCInformations;
